// @flow
import React, {type Node} from 'react';
import styled from 'styled-components';

type Props = {|
  isOpen: boolean,
|};

export function DropdownArrow({isOpen}: Props): Node {
  return (
    <Arrow isOpen={isOpen}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 9l-7 7-7-7"
      />
    </Arrow>
  );
}

const Arrow = styled.svg`
  width: 20px;
  height: 20px;
  color: #9ca3af;
  transform: rotate(${props => (props.isOpen ? '180deg' : '0deg')});
  transition: transform 0.2s ease-in-out;
`;
